const files = require.context('.', false, /\.json$/)

export default files